import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  ShopOrderCsMemo,
  ShopOrderCsMemoCreateDto,
  ShopOrderCsMemoLogParams,
  ShopOrderCsMemoLogResponse,
} from './shopOrderCsMemo.interface';

// 화환 주문 CS 응대 메모 (Admin + 셀러 3롤 공용, 셀러는 자기 매장 주문만)
// 구서버엔 없는 경로 — 404 가능(호출부 가드). 스펙: docs/shop-order-cs-memo-spec.md
const BASE = `/${LowerRole.Admin}/shop-order-cs-memo`;

export const isShopCsMemoNotFound = (e: unknown): boolean =>
  (e as { response?: { status?: number } })?.response?.status === 404;

/** 삭제 엔드포인트 미배포 판별 (404 = 라우트 없음, 405 = 메서드 미허용) */
export const isShopCsMemoDeleteUnsupported = (e: unknown): boolean => {
  const status = (e as { response?: { status?: number } })?.response?.status;
  return status === 404 || status === 405;
};

/** 주문 단위 타임라인 (createdAt 오름차순) */
export const getShopOrderCsMemos = async (
  shopOrder: string,
): Promise<ShopOrderCsMemo[]> => {
  const params = new URLSearchParams({ shopOrder });
  const { data } = await api_.get<ShopOrderCsMemo[]>(`${BASE}?${params}`);
  return data;
};

/**
 * 주문 다건 배치 조회 (목록·카드 화면용, 100개 상한).
 * 메모 없는 주문도 빈 배열로 키가 온다. 남의 매장 주문은 403이 아니라 빈 배열.
 */
export const getShopOrderCsMemosBatch = async (
  shopOrderIds: string[],
): Promise<Record<string, ShopOrderCsMemo[]>> => {
  const params = new URLSearchParams({ shopOrders: shopOrderIds.join(',') });
  const { data } = await api_.get<Record<string, ShopOrderCsMemo[]>>(
    `${BASE}/batch?${params}`,
  );
  return data;
};

/** CS 응대 로그 — 기간·검색으로 훑는 목록 (createdAt 내림차순, 셀러는 자기 매장만) */
export const getShopOrderCsMemoLog = async (
  params: ShopOrderCsMemoLogParams,
): Promise<ShopOrderCsMemoLogResponse> => {
  const query = new URLSearchParams();
  if (params.from) query.set('from', params.from);
  if (params.to) query.set('to', params.to);
  if (params.q) query.set('q', params.q);
  if (params.adminOnly) query.set('adminOnly', '1');
  if (params.page) query.set('page', String(params.page));
  if (params.limit) query.set('limit', String(params.limit));

  const { data } = await api_.get<ShopOrderCsMemoLogResponse>(`${BASE}/log?${query}`);
  return data;
};

export const createShopOrderCsMemo = async (
  dto: ShopOrderCsMemoCreateDto,
): Promise<ShopOrderCsMemo> => {
  const { data } = await api_.post<ShopOrderCsMemo>(BASE, dto);
  return data;
};

/** 소프트 삭제 (오기입 취소) — 중복 호출 멱등 */
export const deleteShopOrderCsMemo = async (id: string): Promise<void> => {
  await api_.delete(`${BASE}/${id}`);
};
